import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Button, Paper, Fade, IconButton, TextField } from '@mui/material';
import { showErrorSnackbar, showSuccessSnackbar } from '../snackBar/snakbar';
import { API, graphqlOperation } from 'aws-amplify';
import TeaxtareaField from '../formElements/TeaxtareaField';

import { useNavigate } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import { Close } from '@mui/icons-material';
import {
  createCrDrNoteMaster,
  createEInvoiceMaster,
  createInvoiceMaster,
  createPurchaseMaster,
  createTransactionWithSpecificTime,
  deletecancelinvoices,
  deleteTransactionMaster,
  getRelatedPaymentDetails,
} from '../../graphql';
import { deleteCrDrBatch, deleteInvoiceMaster, deleteInvoiceMasterTrasaction } from '../../graphql/postgress_graphql/customMutations';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import { setNavigationBlocked } from '../../redux/reducers/controllNavigation';
import { dashboardApi } from '../../redux/apis/dashboardApi';
import { useCreatePdfMutation } from '../../redux/apis/createPdf.api';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  outline: 'none',
  minWidth: '500px',
};

const InvoiceCancel = ({
  open,
  state,
  setState,
  setOpen,
  itemData,
  data,
  setData,
  actionType,
  invoiceEntry,
  transID,
  Type,
  onConfirm,
  vouchers = [],
  path=''
}) => {
  const [createPdf, progress] = useCreatePdfMutation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLodaing] = useState(false);
  const [relatedPayments, setRelatedPayements] = useState([]);
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  // const cancel = async (id, reason) => {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       let payload = {
  //         InvoiceID: id,
  //         CancelFlag: 1,
  //         CancelRemark: state.reason,
  //         PaymentDeleteFlag: data?.paymentDeletionFlag === true ? 1 : 0,
  //       };
  //       let response = await API.graphql(
  //         graphqlOperation(createEInvoiceMaster, {
  //           updateInvoicemasterInput: payload,
  //         })
  //       );
  //       showSuccessSnackbar("Invoice Cancelled");
  //       if (itemData?.nav) {
  //         navigate(itemData?.nav);
  //       }
  //     } catch (error) {
  //       showErrorSnackbar("Something Went Wrong !");
  //       console.log(error);
  //     } finally {
  //       resolve();
  //     }
  //   });
  // };

  // async function deleteInvoice(id, reason) {
  //   let payload = {
  //     InvoiceID: id,
  //     CancelFlag: 1,
  //     CancelRemark: state.reason,
  //     PaymentDeleteFlag: data.paymentDeletionFlag === true ? 1 : 0,
  //   };
  //   setLodaing(true)
  //   Math.floor(new Date().getTime() / 1000);
  //   const exp = Math.floor(new Date().getTime() / 1000);
  //   let masterData = {}
  //   let invTransId = ""
  //   let transactionTypeCD=""
  //   let message = ""
  //   let url = ""
  //   if (Type === "Sales" || Type === "Pos") {
  //     message = Type === "Sales" ? "Invoice Deleted" : "Pos Deleted"
  //     transactionTypeCD=data.paymentType == "Cash"?"CashReceipt":"BankReceipt"
  //     invTransId = invoiceEntry?.relatedinvoicetransactiondetails[0]?.transactionid
  //     url = Type === "Sales" ? "/salesInvoiceReport" : "/allpos"
  //     masterData = {
  //       adjustmentamount: 0,
  //       comments: "",
  //       expiredtimestamp: exp,
  //       reversechargeflag: data.reverseChargeFlag,
  //       balancedueamount: Number(data.balanceDueAmt),
  //       creditduration: Number(data?.creditPeriod),
  //       customerordernumber: 0,
  //       customerorderdate:
  //         data?.customerOrderDate === ""
  //           ? 0
  //           : Math.floor(new Date(data?.customerOrderDate).getTime() / 1000),
  //       exchangerate: Number(data?.receivedAmount),
  //       invoiceamount: 0,
  //       invoicebillingaddressid: 10,
  //       invoicetaxabletypecd: "",
  //       invoicecurrencycd: "",
  //       invoicedate: 0,
  //       invoicedeliveryaddressid: 10,
  //       invoiceid: invoiceEntry.invoiceid,
  //       invoicenumber: data.voucherNumber,
  //       serialnumber: data.seriesVouchers.value,
  //       invoicetypecd: "SalesInvoice",
  //       partyid: 0,
  //       paymentaccountid:
  //         0,
  //       placeofsupply: "",

  //       paymenttype: "",
  //       receipturl: "",
  //       receivedamount: 0,
  //       tcsapplicableflag: data.tcsFlag,
  //       consigneename:
  //         "",
  //       consigneegstin:
  //         "",
  //       companystate: "",
  //       roundoffamount: Number(data.roundOff),
  //       discounttype: Number(data.adjustmentsType),
  //       discountvalue: Number(data.adjustmentsValue),
  //       currencycode: String(data.currency.value),
  //       currencyrate: Number(data.currencyRate),
  //       cancelremark: "",
  //       deleteremark: "",
  //       financialyearid: userPreferece?.financialYear?.financialyearid,
  //       cancelflag: 0,
  //       invoicelinetyped: "",
  //       paymentstatus: 0,
  //     };
  //   }
  //   if (Type === "Purchase") {
  //     transactionTypeCD=data.paymentType == "Cash"?"CashPayment":"BankPayment"
  //     url = "/allpurchaseandexpense"
  //     message = "Purchase Deleted"
  //     invTransId = invoiceEntry?.relatedpurchasetransactiondetails[0]?.transactionid
  //     masterData = {
  //       adjustmentamount: 0,
  //       balancedueamount: 0,
  //       comments: "",
  //       creditduration: 0,

  //       expiredtimestamp: exp,
  //       entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
  //       granttotalamount: 0,
  //       paidamount: 0,
  //       paymentaccountid: 0
  //       ,
  //       paymentclearedflag: 0,
  //       paymenttypecd: "",
  //       purchasegsttypecd: "",
  //       purchaseid: invoiceEntry?.purchaseid,
  //       placeofsupply: "",
  //       supplieraddressid: 10,
  //       supplierid: 0,
  //       supplierinvoicedate: Math.floor(
  //         new Date(data.customerOrderDate).getTime() / 1000
  //       ),
  //       supplierinvoicenumber:
  //         data.orderNumber === "" ? 0 : data.orderNumber,
  //       tdsapplicableflag: 0,
  //       vouchernumber: data.voucherNumber,
  //       serialnumber: data.seriesVouchers.value,
  //       companystate: "",
  //       discounttype: data.adjustmentsType,
  //       discountvalue: Number(data.adjustmentsValue),
  //       roundoffamount: Number(data.roundOff),
  //       currencycode: data.currency.value,
  //       currencyrate: data.currencyRate,
  //       reversechargeflag: data.reverseChargeFlag,
  //       partyregistrationtype: data.partyCategory,
  //       cancelremark: "",
  //       deleteremark: "",
  //       financialyearid: userPreferece?.financialYear?.financialyearid,
  //       cancelflag: 0,
  //       paymentstatus: 0,
  //       companybranchid: 0,
  //     };
  //   }
  //   if (Type === "DebitNote" || Type === "CreditNote") {
  //     transactionTypeCD=Type === "CreditNote"?(data.paymentType == "Cash"?"CashPayment":"BankPayment"):(data.paymentType == "Cash"?"CashReceipt":"BankReceipt")
  //     message = Type === "DebitNote" ? "DebitNote Deleted" : "CreditNote Deleted"
  //     invTransId = invoiceEntry?.transactionid
  //     url = Type === "DebitNote" ? "/alldebitnote" : "/allcreditnote"
  //     masterData = {
  //       crdrnotedate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
  //       crdrnoteid: invoiceEntry.crdrnoteid,
  //       crdrnotetypecd: Type,
  //       deliveryaddressid: 0,
  //       gsttypecd: "",
  //       grandtotalamount: 0,
  //       invoicetypecd: "",
  //       creditduration: data.creditPeriod === "" ? 0 : data.creditPeriod,
  //       partyid: 0,
  //       paymenttype: "",
  //       transactionid: invoiceEntry?.transactionid,
  //       psflag: 0,
  //       reversechargeflag: data.reverseChargeFlag,
  //       balancedueamount: Number(data.balanceDueAmt),
  //       crdrnotenumber: data?.voucherNumber,
  //       serialnumber: data.seriesVouchers.value,
  //       consigneename: "",
  //       consigneegstin: -"",
  //       placeofsupply: "",
  //       cancelflag: 0,
  //       companystate: "",
  //       discounttype: data.adjustmentsType,
  //       adjustmentamount: Number(data.adjustments),
  //       discountvalue: Number(data.adjustmentsValue),
  //       roundoffamount: Number(data.roundOff),
  //       currencycode: data.currency.value,
  //       currencyrate: data.currencyRate,
  //       originalinvoicenumber: "",
  //       companybranchid: 0,
  //       expiredtimestamp: exp,
  //       cancelremark: ""
  //     };
  //   }

  //   try {
  //     if (Type === "Sales" || Type === "Pos") {
  //       const res = await API.graphql(
  //         graphqlOperation(createInvoiceMaster, {
  //           createInvoiceMasterInput: masterData,
  //         })
  //       );
  //     }
  //     if (Type === "Purchase") {
  //       const res = await API.graphql(
  //         graphqlOperation(createPurchaseMaster, {
  //           createPurchaseMasterInput: masterData,
  //         })
  //       );
  //     }
  //     if (Type === "DebitNote" || Type === "CreditNote") {
  //       const res = await API.graphql(
  //         graphqlOperation(deleteCrDrBatch, {
  //           createCrDrNoteMasterInput: masterData,
  //         })
  //       );
  //     }

  //     const deleteInvTransMaster = await API.graphql(
  //       graphqlOperation(deleteTransactionMaster, {
  //         transactionid: invTransId,
  //       })
  //     );

  //     if ((transID !== "" && transID !== undefined && transID !== null) && data?.paymentDeletionFlag === true) {
  //       const deleteTransMaster = await API.graphql(
  //         graphqlOperation(deleteTransactionMaster, {
  //           invoicetype:"",
  //         })
  //       );
  //     }
  //     showSuccessSnackbar(message);
  //     navigate(url);

  //   } catch (error) {
  //     setLodaing(false)
  //     console.log(error);
  //   }
  // }

  // async function cancelInvoice(id, reason) {

  //   setLodaing(true)
  //   let transMsterArr=[]
  //   let transDetailsArr=[]
  //   Math.floor(new Date().getTime() / 1000);
  //   const exp = Math.floor(new Date().getTime() / 1000);
  //   let masterData = {}
  //   let invTransId = ""
  //     let transactionTypeCD=""
  //   let message = ""
  //   let url = ""
  //   const comments = data.remarks.split("\n");
  //   if (Type === "Sales" || Type === "Pos") {
  //     message = Type === "Sales" ? "Invoice Cancelled" : "Pos Cancelled"
  //     transactionTypeCD=data.paymentType == "Cash"?"CashReceipt":"BankReceipt"
  //     invTransId = invoiceEntry?.relatedinvoicetransactiondetails[0]?.transactionid

  //     url = Type === "Sales" ? "/salesInvoiceReport" : "/allpos"
  //      masterData = {
  //       adjustmentamount: Number(data?.adjustments),
  //       comments: comments.join("**"),
  //       expiredtimestamp: 0,
  //       reversechargeflag: data.reverseChargeFlag,
  //       balancedueamount: Number(data.balanceDueAmt),
  //       creditduration: Number(data?.creditPeriod),
  //       customerordernumber: data?.orderNumber === "" ? 0 : Number(data?.orderNumber),
  //       customerorderdate:
  //         data?.customerOrderDate === ""
  //           ? 0
  //           : Math.floor(new Date(data?.customerOrderDate).getTime() / 1000),
  //       exchangerate: Number(data?.receivedAmount),
  //       invoiceamount: netAmountToPay,
  //       invoicebillingaddressid: 10,
  //       invoicetaxabletypecd: String(data?.taxability?.value),
  //       invoicecurrencycd: "",
  //       invoicedate: Math.floor(new Date(data?.invoiceDate).getTime() / 1000),
  //       invoicedeliveryaddressid: 10,
  //       invoiceid: invoiceEntry.invoiceid,
  //       invoicenumber: data.voucherNumber,
  //       serialnumber: data.seriesVouchers.value,
  //       invoicetypecd:Type==="Pos"?"PosInvoice": "SalesInvoice",
  //       partyid:Type==="Pos"?invoiceEntry.relatedinvoiceposdetails[0]?.relatedposparty[0]
  //       ?.pospartyid: data?.partyName.value,
  //       paymentaccountid:
  //         data?.receivedAccount.value == "" ? 0 : data?.receivedAccount.value,
  //       placeofsupply: String(data?.placeOfSupply.value),

  //       paymenttype: data?.paymentType,
  //       receipturl: "",
  //       receivedamount:Number(data?.receivedAmount),
  //       tcsapplicableflag: data.tcsFlag,
  //       consigneename:Type==="Pos"?"":
  //        ( data.consigneeName !== ""
  //           ? data.consigneeName
  //           : data.partyName.label),
  //       consigneegstin:Type==="Pos"?"":
  //         (data.consigneeGST !== "" &&
  //         data.consigneeGST !== undefined &&
  //         data.consigneeGST !== null
  //           ? data.consigneeGST
  //           : data.gstin !== "" &&
  //             data.gstin !== undefined &&
  //             data.gstin !== null
  //           ? data?.gstin
  //           : ""),
  //       companystate: String(companyState),
  //       roundoffamount: Number(data.roundOff),
  //       discounttype: Number(data.adjustmentsType),
  //       discountvalue: Number(data.adjustmentsValue),
  //       currencycode: String(data.currency.value),
  //       currencyrate: Number(data.currencyRate),
  //       cancelremark: "",
  //       deleteremark: "",
  //       financialyearid: userPreferece?.financialYear?.financialyearid,
  //       cancelflag: 1,
  //       invoicelinetyped: "",
  //       paymentstatus: 0,
  //     };
  //   }
  //   if (Type === "Purchase") {
  //     url = "/allpurchaseandexpense"
  //     message = "Purchase Cancelled"

  //     transactionTypeCD=data.paymentType == "Cash"?"CashPayment":"BankPayment"
  //     invTransId = invoiceEntry?.relatedpurchasetransactiondetails[0]?.transactionid
  //     masterData = {
  //       adjustmentamount: Number(data?.adjustments),
  //       balancedueamount: Number(data.balanceDueAmt),
  //       comments: comments.join("**"),
  //       creditduration: isNaN(Number(data?.creditPeriod))
  //         ? 0
  //         : Number(data?.creditPeriod),
  //       expiredtimestamp: 0,
  //       entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
  //       granttotalamount: Number(netAmountToPay),
  //       paidamount: data?.paymentDeletionFlag === true ? 0 : Number(data?.receivedAmount),
  //       paymentaccountid:
  //         data?.receivedAccount.value === "" ? 0 : data?.receivedAccount.value,
  //       paymentclearedflag: 0,
  //       paymenttypecd: data?.paymentType,
  //       purchasegsttypecd: String(data?.taxability?.value),
  //       purchaseid: invoiceEntry?.purchaseid,
  //       placeofsupply: String(data?.placeOfSupply.value),
  //       supplieraddressid: 10,
  //       supplierid: data?.partyName.value,
  //       supplierinvoicedate: Math.floor(
  //         new Date(data.customerOrderDate).getTime() / 1000
  //       ),
  //       supplierinvoicenumber:
  //         data.orderNumber === "" ? 0 : data.orderNumber,
  //       tdsapplicableflag: 0,
  //       vouchernumber: data?.voucherNumber,
  //       serialnumber: data.seriesVouchers.value,
  //       companystate: String(companyState),
  //       discounttype: data.adjustmentsType,
  //       discountvalue: Number(data.adjustmentsValue),
  //       roundoffamount: Number(data.roundOff),
  //       currencycode: data.currency.value,
  //       currencyrate: data.currencyRate,
  //       reversechargeflag: data.reverseChargeFlag,
  //       partyregistrationtype: data.partyCategory,
  //       cancelremark: "",
  //       deleteremark: "",
  //       financialyearid: userPreferece?.financialYear?.financialyearid,
  //       cancelflag: 1,
  //       paymentstatus: 0,
  //       companybranchid: 0,
  //     };

  //   }
  //   if (Type === "DebitNote" || Type === "CreditNote") {
  //     message = Type === "DebitNote" ? "DebitNote Cancelled" : "CreditNote Cancelled"
  //     transactionTypeCD=Type === "CreditNote"?(data.paymentType == "Cash"?"CashPayment":"BankPayment"):(data.paymentType == "Cash"?"CashReceipt":"BankReceipt")

  //     invTransId = invoiceEntry?.transactionid
  //     url = Type === "DebitNote" ? "/alldebitnote" : "/allcreditnote"
  //     let invoNos = [];
  //     data.originalInvoiceNumber.map((ele) => {
  //       invoNos.push(ele.value);
  //     });
  //     masterData =  {
  //       crdrnotedate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
  //       crdrnoteid: invoiceEntry.crdrnoteid,
  //       crdrnotetypecd:Type,
  //       deliveryaddressid: 0,
  //       gsttypecd: String(data?.taxability?.value),
  //       grandtotalamount: Number(netAmountToPay),
  //       invoicetypecd: "",
  //       creditduration: data.creditPeriod === "" ? 0 : data.creditPeriod,
  //       partyid: data?.partyName.value,
  //       paymenttype: data?.paymentType,
  //       transactionid: invoiceEntry?.transactionid,
  //       psflag: 0,
  //       reversechargeflag: data.reverseChargeFlag,
  //       balancedueamount: Number(data.balanceDueAmt),
  //       crdrnotenumber: data?.voucherNumber,
  //       serialnumber: data.seriesVouchers.value,
  //       consigneename:
  //         data.consigneeName !== ""
  //           ? data.consigneeName
  //           : data.partyName.label,
  //       consigneegstin:
  //         data.consigneeGST !== "" ? data.consigneeGST : data.gstin,
  //       placeofsupply: String(data?.placeOfSupply.value),
  //       cancelflag: 1,
  //       companystate: companyState,
  //       discounttype: data.adjustmentsType,
  //       adjustmentamount: Number(data.adjustments),
  //       discountvalue: Number(data.adjustmentsValue),
  //       roundoffamount: Number(data.roundOff),
  //       currencycode: data.currency.value,
  //       currencyrate: data.currencyRate,
  //       originalinvoicenumber: invoNos.join(","),
  //       companybranchid: 0,
  //       expiredtimestamp: 0,
  //       cancelremark: ""
  //     };
  //   }

  //   try {
  //     if (Type === "Sales" || Type === "Pos") {
  //       const res = await API.graphql(
  //         graphqlOperation(createInvoiceMaster, {
  //           createInvoiceMasterInput: masterData,
  //         })
  //       );
  //     }
  //     if (Type === "Purchase") {
  //       const res = await API.graphql(
  //         graphqlOperation(createPurchaseMaster, {
  //           createPurchaseMasterInput: masterData,
  //         })
  //       );
  //     }
  //     if (Type === "DebitNote" || Type === "CreditNote") {
  //       const res = await API.graphql(
  //         graphqlOperation(createCrDrNoteMaster, {
  //           createCrDrNoteMasterInput: masterData,
  //         })
  //       );
  //     }

  //     const invTransMaster = {
  //       transactionid: invTransId,
  //       bankreferencenumber: "",
  //       entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
  //       expiredtimestamp:0,
  //       comments: "",
  //       vouchernumber: data?.voucherNumber,
  //       serialnumber: "",
  //       transactiontypecd:
  //         "",
  //           cancelflag:1
  //     };
  //     transMsterArr.push(invTransMaster)
  //     invTransArr.map((ele, ind) => {
  //       let obj = {
  //         accountid: ele.accID,
  //         comments: data.remarks,
  //         debitamount: Number(ele.debitAmt).toFixed(2),
  //         creditamount: Number(ele.creditAmt).toFixed(2),
  //         entryordernumber: ind + 1,
  //         transactionid:
  //         invTransId,
  //         transactiontypecd: ele.debitAmt !== 0 ? "Debit" : "Credit",
  //         enteredtimestamp: Math.floor(
  //           new Date(data.invoiceDate).getTime() / 1000
  //         ),
  //         cancelflag:1,
  //         expiredtimestamp:0,
  //       };
  //       transDetailsArr.push(obj);
  //     });

  //     if ((transID !== "" && transID !== undefined && transID !== null) && data?.paymentDeletionFlag === true) {
  //     const transMaster = {
  //       transactionid: transID,
  //       bankreferencenumber: data.bankReferenceNo,
  //       entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
  //       comments: "",
  //       vouchernumber: data.transactionVoucher,
  //       serialnumber: data.transactionSeries.value,
  //       transactiontypecd:
  //       transactionTypeCD,
  //           cancelflag:1
  //     };
  //     paymentTransArr.map((ele, index) => {
  //       const paymentTransDetails = {
  //         accountid: ele.accID,
  //         comments: data.remarks,
  //         creditamount: Number(ele.creditAmt),
  //         debitamount: Number(ele.debitAmt),
  //         entryordernumber: index + 1,
  //         transactionid: transID,
  //         transactiontypecd: ele.debitAmt !== 0 ? "Debit" : "Credit",
  //         enteredtimestamp: Math.floor(
  //           new Date(data.invoiceDate).getTime() / 1000
  //         ),
  //         cancelflag:1
  //       };
  //       transDetailsArr.push(paymentTransDetails);
  //     });
  //       transMsterArr.push(transMaster)

  //     }

  //      const result = await API.graphql(
  //               graphqlOperation(createTransactionWithSpecificTime, {
  //                 transactionmaster: JSON.stringify(transMsterArr),
  //                 transactiondetails: JSON.stringify(transDetailsArr),
  //                 transactionattachment: JSON.stringify([]),
  //                 transactiontdsdetails: JSON.stringify([]),
  //                 transactionrelation: JSON.stringify([]),
  //                 mode: 0,
  //                 transactiontcsdetails: JSON.stringify([]),
  //               })
  //             );

  //     showSuccessSnackbar(message);
  //     navigate(url);

  //   } catch (error) {
  //     setLodaing(false)
  //     console.log(error);
  //   }
  // }
  async function getRelatedPayments() {
    try {
      let invID = 0;
      let invType = '';
      if (Type === 'Sales') {
        invID = invoiceEntry.invoiceid;
        invType = 'SalesInvoice';
      }
      if (Type === 'Pos') {
        invID = invoiceEntry.invoiceid;
        invType = 'PosInvoice';
      }
      if (Type === 'Purchase') {
        invID = invoiceEntry.purchaseid;
        invType = 'PurchaseInvoice';
      }
      if (Type === 'DebitNote') {
        invID = invoiceEntry.crdrnoteid;
        invType = 'DebitNote';
      }
      if (Type === 'CreditNote') {
        invID = invoiceEntry.crdrnoteid;
        invType = 'CreditNote';
      }
      const res = await API.graphql(
        graphqlOperation(getRelatedPaymentDetails, {
          invoicetype: invType,
          id: invID,
        })
      );
      if (res?.data?.getRelatedPaymentDetails.length > 0) {
        setRelatedPayements(res?.data?.getRelatedPaymentDetails);
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  useEffect(() => {
    getRelatedPayments();
  }, []);

  let handleClose = () => {
    setOpen(false);
    if (setData) {
      setData((prev) => ({
        ...prev,
        paymentDeletionFlag: false,
      }));
    }
  };

  async function deleteOrCancelInvoices(reason) {
    let pdfType=Type === 'Sales'?'salesInvoice':Type==='Pos'?'pos' : Type === 'Purchase' ? 'purchaseInvoice' :Type==='DebitNote'? 'drnoteMaster':'crnoteMaster';
    let Id =
      Type === 'Sales' || Type === 'Pos' ? invoiceEntry.invoiceid : Type === 'Purchase' ? invoiceEntry.purchaseid : invoiceEntry.crdrnoteid;
    let mode = itemData?.todo == 'cancel' ? 'CANCEL' : 'DELETE';
    let paymentincluded = 1;

    let message = '';
    let url =
      Type === 'Sales'
        ? '/salesInvoiceReport'
        : Type === 'Pos'
        ? '/allpos'
        : Type === 'Purchase'
        ? '/allpurchaseandexpense'
        : Type === 'CreditNote'
        ? '/allcreditnote'
        : '/alldebitnote';

    if (itemData?.todo == 'cancel') {
      message =
        Type === 'Sales'
          ? 'Sales Invoice Cancelled!'
          : Type === 'Pos'
          ? 'Pos Invoice Cancelled!'
          : Type === 'Purchase'
          ? 'Purchase Invoice Cancelled!'
          : Type === 'CreditNote'
          ? 'Credit Note Cancelled!'
          : 'Debit Note Cancelled!';
    } else {
      message =
        Type === 'Sales'
          ? 'Sales Invoice Deleted!'
          : Type === 'Pos'
          ? 'Pos Invoice Deleted!'
          : Type === 'Purchase'
          ? 'Purchase Invoice Deleted!'
          : Type === 'CreditNote'
          ? 'Credit Note Deleted!'
          : 'Debit Note Deleted!';
    }
    try {
      const res = await API.graphql(
        graphqlOperation(deletecancelinvoices, {
          invoicetype: Type,
          invoiceid: Id,
          mode: mode,
          paymentincluded: paymentincluded,
          reason: reason,
        })
      );

      if (res?.data?.deletecancelinvoices !== null) {
        createPdf({
          path: path,
          type: pdfType,
          invoiceids: Id,
        });
        showSuccessSnackbar(message);
        dispatch(dashboardApi.util.invalidateTags(['dashboard',"bizview"]));
        navigate(url);
      }
    } catch (error) {
      console.log('error', error);
      showErrorSnackbar('Something went wrong! Please try again');
    } finally {
      dispatch(setNavigationBlocked(false));
    }
  }
  let handleCancel = async () => {
    if (onConfirm) {
      onConfirm();
    } else if (itemData.fn) {
      await itemData.fn(data?.paymentDeletionFlag);
      handleClose();
    } else {
      // if (itemData?.todo == "cancel") {
      //   await cancelInvoice(itemData.id, state.reason);
      // } else {
      //   await deleteInvoice(itemData.id, state.reason);
      // }
      await deleteOrCancelInvoices(state?.reason);
    }
  };
  return (
    <Modal
      id={open ? 'invoiseCancel' : ''}
      open={open}
      onClose={handleClose}
      aria-labelledby="invoice-cancel-modal-title"
      aria-describedby="invoice-cancel-modal-description"
    >
      <Fade in={open}>
        <Paper sx={style}>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: '5px 15px',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                Warning
                <IconButton aria-label="delete" onClick={handleClose}>
                  <Close sx={{ color: '#fff' }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
          <Box sx={{ p: 1 }}>
            <Typography id="invoice-cancel-modal-title" variant="h6" component="h2">
              Are you sure you want to {itemData?.todo || 'cancel '} this&nbsp;
              {itemData?.from || 'Invoice'} ?
            </Typography>
            {vouchers?.length > 0 ? (
              <div>
                <Typography sx={{ fontSize: '12.5px', mt: 2, mb: 2 }}>
                  The following Invoices linked with this {itemData?.from} will be unlinked immediately.
                </Typography>
                {vouchers.map((ele, index) => {
                  if (ele.TransactionID) {
                    return (
                      <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox checked={true} disabled={true}></Checkbox>
                        <Typography
                          key={index}
                          id="invoice-cancel-modal-description"
                          component="p"
                          sx={{ fontSize: '12.5px', mt: 1, mb: 1 }}
                        >
                          <b>
                            <span style={{ color: '#FF0000' }}>
                              {ele?.ObjectAttribute} ₹{MoneyFormatv3(ele?.LinkedAmount)}
                            </span>
                          </b>
                        </Typography>
                      </div>
                    );
                  }
                })}
              </div>
            ) : (
              ''
            )}
            {relatedPayments?.length > 0 ? (
              // <Typography id="invoice-cancel-modal-description" component="p" sx={{ fontSize: '14.5px', color: "#FF0000", mt: 2, mb: 2 }}>
              //     <b>
              //         <span style={{ textDecoration: "underline", fontSize: "15px" }}> NOTE:</span> All the {(itemData?.from == "purchase" || itemData?.from == "credit") ? "payment" : "receipt "} linked with this invoice will be {itemData?.todo || " Cancelled"} immediately. <br />
              //         You can't undo this action.
              //     </b>
              // </Typography>
              <Typography
                id="invoice-cancel-modal-description"
                component="p"
                sx={{
                  fontSize: '14.5px',
                  mt: 2,
                  mb: 2,
                  display: 'flex',
                  alignItems: 'center',
                }} // Align items vertically in the center
              >
                {/* <Box sx={{ display: "flex", alignItems: "center" }}> */}
                {/* <Checkbox
                  color="primary"
                  checked={data?.paymentDeletionFlag}
                  onChange={(e) => {
                    setData((prev) => ({
                      ...prev,
                      paymentDeletionFlag:
                        e.target.checked === true ? true : false,
                    }));
                  }}
                /> */}
                <span style={{ marginLeft: 1, fontSize: '12px', color: 'red' }}>
                  <b>
                    {itemData?.from === 'purchase' || itemData?.from === 'credit'
                      ? `Note: ${itemData?.todo === 'cancel' ? 'Cancelling' : 'Deleting'} ${
                          itemData?.from
                        } will unlink the corresponding payments. Are you sure you want to proceed?`
                      : `Note:  ${itemData?.todo === 'cancel' ? 'Cancelling' : 'Deleting'}  ${
                          itemData?.from
                        } will unlink the corresponding receipts. Are you sure you want to proceed?`}
                    {/* // (relatedPayments?.length===1?`${actionType} the Receipt Voucher`:`${actionType} the Receipt Vouchers`)} */}{' '}
                    <span style={{ color: '#FF0000' }}>{data?.transactionVoucher}</span>
                  </b>
                </span>
                {/* </Box> */}
              </Typography>
            ) : null}
            <Box sx={{ marginTop: '8px' }}>
              <TeaxtareaField
                name="reason"
                placeholder={`Reason for ${itemData?.todo == 'cancel' ? ' Cancellation' : ' Deletion'} ${'(If any)'}`}
                // placeholder={` ${itemData?.todo == "cancel" ? " Cancellation" : " Deletion"} Reason (optional)`}
                size="small"
                fullWidth
                rows={6}
                state={state}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length > 250) {
                    setState((prev) => ({
                      ...prev,
                      reason: value,
                      errorStatus: {
                        ...prev?.errorStatus,
                        reason: true,
                      },
                      errorFields: {
                        ...prev?.errorFields,
                        reason: `Reason for ${itemData?.todo == 'cancel' ? ' Cancellation' : ' Deletion'} must be less than 250 characters`,
                      },
                    }));
                  } else if (value.length <= 0) {
                    setState((prev) => ({
                      ...prev,
                      reason: value,
                      errorStatus: {
                        ...prev.errorStatus,
                        reason: true,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        reason: `Reason for ${itemData?.todo == 'cancel' ? ' Cancellation' : ' Deletion'} is Required`,
                      },
                    }));
                  } else {
                    setState((prev) => ({
                      ...prev,
                      reason: value,
                      errorStatus: {
                        ...prev.errorStatus,
                        reason: false,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        reason: '',
                      },
                    }));
                  }
                }}
              />
            </Box>

            <Box sx={{ marginTop: '16px', textAlign: 'right' }}>
              <Button variant="outlined" onClick={handleClose} sx={{ marginRight: '8px' }}>
                Cancel
              </Button>
              <LoadingButton
                color="error"
                sx={{ flex: 1, margin: '5px', fontSize: '12px' }}
                loading={loading}
                disableRipple={true}
                variant="contained"
                onClick={() => handleCancel()}
              >
                Confirm {itemData?.todo == 'cancel' ? ' Cancellation' : ' Deletion'}
              </LoadingButton>
            </Box>
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default InvoiceCancel;
